import React from 'react';
import classes from './Modal.module.scss';

const ModalContainer = ({ children }) => {
  return <div className={classes.Modal}>{children}</div>;
};

export default React.memo(ModalContainer);
